import { Injectable } from '@angular/core';
import { User } from '../models/user';
import {Observable} from 'rxjs/Observable';
import {Restangular} from 'ngx-restangular';

export interface GenericResponse<T> {
    success: boolean;
    message: string;
    data?: T;
}

export class Navigation {
  public menus: Menu[];
  public permissions: string[];
}

export class Menu {
  public title: string;
  public icon: string;
  public mainModule: string;
  public link: string;
  public sublinks: Menu[];
}
export class SmsSummaryConfig {
    public smsDateRange: any;
    public isSmsSummaryEnabled: boolean;
}

@Injectable()
export class AuthDataService {

    private currentUser: User;
    private navigation: Navigation;
    private smsSummaryConfig: SmsSummaryConfig;

    constructor(private restangular: Restangular) { }

    getCurrentUser(): User {
        return this.currentUser;
    }

    setCurrentUser(currentUser: User) {
        this.currentUser = currentUser;
    }

    getNavigation() {
        return this.navigation;
    }

    setNavigation(navigation: Navigation) {
        this.navigation = navigation;
    }

    getSmsSummaryConfig(): Observable<any> {
        return this.restangular.all("reports/sms/summary/config").customGET();
    }

    initializeSmsSummaryConfig(): Promise<any> {
        return this.getSmsSummaryConfig().toPromise().then(data => {
            this.smsSummaryConfig = data;
            return data;
        });
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/auth-data.service.ts